/**
 * Cores principais dos sistemas SCI
 * Definidas conforme especificação do usuário
 */
export const SYSTEM_MAIN_COLORS = {
  VCON: '#82B982',
  VPRA: '#84d6fc', 
  VSUC: '#2077BD',
  VSUP: '#57A4E4',
  VSYN: '#B2C58A'
}

/**
 * Cores do Vuetify para compatibilidade com componentes
 * Mantém as cores antigas para não quebrar funcionalidades existentes
 */
export const SYSTEM_VUETIFY_COLORS = {
  VCON: 'purple',
  VPRA: 'info',
  VSUC: 'success',
  VSUP: 'warning',
  VSYN: 'teal'
}

/**
 * Função para obter a cor principal de um sistema
 * @param {string} sistema - Nome do sistema (VCON, VPRA, VSUC, VSUP, VSYN)
 * @returns {string} Código hexadecimal da cor
 */
export function getSystemMainColor(sistema) {
  return SYSTEM_MAIN_COLORS[sistema] || '#grey'
}

/**
 * Função para obter a cor do Vuetify de um sistema
 * @param {string} sistema - Nome do sistema (VCON, VPRA, VSUC, VSUP, VSYN)
 * @returns {string} Nome da cor do Vuetify
 */
export function getSystemVuetifyColor(sistema) {
  return SYSTEM_VUETIFY_COLORS[sistema] || 'grey'
}
